import { styled } from '../../theme'

interface PanelProps {
  position: number
  total: number
  $noBorder?: boolean
  $compactTop?: boolean
  /** When true, use smaller bottom padding (e.g. V3 panel to align with action button spacing) */
  $compactBottom?: boolean
}

export const PanelContainer = styled.div<PanelProps>`
  background-color: white;
  border: ${(props) => (props.$noBorder ? 'none' : `1px solid ${props.theme.colors.lightGray}`)};
  border-radius: 5px;
  min-height: 100%;
  margin-left: 1.3rem;
  padding-bottom: ${(props) => (props.$compactBottom ? '12px' : '1rem')};
  margin-top: ${(props) => (props.$compactTop ? '8px' : '25px')};
`
